import { twMerge } from "tailwind-merge";

export const StatCard = ({
  title,
  stat,
  subtitle,
  className,
}: {
  title: string;
  stat: string;
  subtitle: string;
  className?: string;
}) => {
  return (
    <div
      className={twMerge(
        "flex w-full min-w-[250px] flex-col justify-center rounded-lg border border-zinc-300 p-4 @2xl:min-w-0",
        className,
      )}
    >
      <span className="block text-sm font-semibold">{title}</span>
      <span className="my-2 block text-xl font-semibold">{stat}</span>
      <span className="block text-sm">{subtitle}</span>
    </div>
  );
};
